import { render } from "./UserVoucherSavePage.vue?vue&type=template&id=4d2cfcfb"
import script from "./UserVoucherSavePage.vue?vue&type=script&lang=js"
export * from "./UserVoucherSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script